<template>
    <v-card>
        <v-card-title>
        <span class="headline">Vessel Flag Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newFlag">
                <v-text-field :label="labels.vesFlag" v-model="flagForm.vesFlag" :error-messages="errors.collect('vesFlag')" data-vv-name="vesFlag" :data-vv-as="labels.vesFlag" v-validate="'required|param|max:8'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.vesFlag}}</v-subheader>
                <div class="title">{{flagForm.vesFlag}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="flagForm.vesFlagDesc" :label="labels.vesFlagDesc" :error-messages="errors.collect('vesFlagDesc')" v-validate="'required|entry|max:80'" data-vv-name="vesFlagDesc" :data-vv-as="labels.vesFlagDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'flagForm': Object,
    'newFlag': Boolean
  },
  data() {
    return {
      labels: {
        vesFlag: 'Flag Code*',
        vesFlagDesc: 'Flag Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.flagForm.vesFlag = undefined
      this.flagForm.vesFlagDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newFlag) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vessel.menu.createFlag
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.flagForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vessel.menu.updateFlag
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.flagForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
